//单选控件
import React, { Component } from 'react';
import './CheckControl.less';

const EnabledEnum = {Enable:"enable",DisEnable:'disEnable'};

class CheckControl extends Component {

  constructor(props, context) {
    super(props, context);
  }


  render() {
    const { Title, value ,enable} = this.props;
    const className = `icon iconfont ${value ? 'icon-yixuan' : 'icon-fuxuankuang'} ${value ? 'checkicon' : 'uncheckicon'}`;

    let style = {};
    if (enable == EnabledEnum.DisEnable) {
      style.background = "#eeeeee";
    }

    return (
      <div className='buttonGroup' onClick={this.handleChange}>
        <p style={style} className={className} />
        <p>{Title}</p>
      </div>);
  }

  //点击时间
  handleChange = (e) => {
    e.preventDefault();
    if(this.props.templateItem && this.props.templateItem.ReadOnly === true){
      return;
    }
    const { onCheck,value } = this.props;
    if (onCheck)
      onCheck(!value);
  }
}
export default CheckControl;
